import { render, staticRenderFns } from "./ShippoApiKey.vue?vue&type=template&id=167d4054&"
import script from "./ShippoApiKey.vue?vue&type=script&lang=ts&"
export * from "./ShippoApiKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports